module Client.Pages

open Elmish.UrlParser

[<RequireQualifiedAccess>]
type Page =
  | Login
  | Home
  | MeterReadings
  | ServiceCalls
  | Supplies
  | EquipmentLookup of (string)
  | Equipment
  | Location of int
  | Locations
  | LocationEquipments of int
  | LocationEquipment of int * int
  | LocationInvoices of int
  | LocationInvoice of int * int

let curry f x y = f (x, y)

let toHash =
  function
  | Page.Home -> "#"
  | Page.Login -> "#login"
  | Page.MeterReadings -> "#meterreadings"
  | Page.ServiceCalls -> "#service"
  | Page.Supplies -> "#supplies"
  | Page.EquipmentLookup _ -> "#equipment/lookup"
  | Page.Equipment -> "#equipment"
  | Page.Location locationId -> $"#location/%i{locationId}"
  | Page.Locations -> "#locations"
  | Page.LocationEquipments v -> $"#location/%i{v}/equipment"
  | Page.LocationEquipment (locationId, equipmentId) -> $"#location/%i{locationId}/equipment/%i{equipmentId}"
  | Page.LocationInvoices v -> $"#location/%i{v}/invoices"
  | Page.LocationInvoice (locationId, invoiceId) -> $"#location/%i{locationId}/invoice/%i{invoiceId}"

let pageParser : Parser<Page -> Page, _> =
  oneOf [ map Page.Home (s "")
          map Page.Login (s "login")
          map Page.MeterReadings (s "meterreadings")
          map Page.ServiceCalls (s "service")
          map Page.Supplies (s "supplies")
          map Page.EquipmentLookup (s "equipment" </> s "lookup" </> str)
          map Page.Equipment (s "equipment")
          map Page.Location (s "location" </> i32)
          map Page.Locations (s "locations")
          map Page.LocationEquipments (s "location" </> i32 </> s "equipment")
          map (curry Page.LocationEquipment) (s "location" </> i32 </> s "equipment" </> i32)
          map Page.LocationInvoices (s "location" </> i32 </> s "invoices")
          map (curry Page.LocationInvoice) (s "location" </> i32 </> s "invoice" </> i32)
        ]

let urlParser location = parseHash pageParser location
